import React from "react";

/*
 * In-page loading state for the agents screens. Replaces BrandedBootLoader here:
 * that is the app's full-screen boot splash (position: fixed over everything),
 * so using it for a route change blanked the header, nav and rail and made every
 * agent open look like a full page reload.
 */
const AgentPageSkeleton = () => (
  <div className="ag-page" aria-busy="true" aria-label="Loading agent">
    <div className="ag-skel">
      <span className="ag-skel__back linear-background" />
      <span className="ag-skel__title linear-background" />
      <span className="ag-skel__sub linear-background" />
      <div className="ag-skel__grid">
        <span className="ag-skel__card linear-background" />
        <span className="ag-skel__card linear-background" />
      </div>
      <div className="ag-skel ag-skel--rows">
        <span className="linear-background" />
        <span className="linear-background" />
        <span className="linear-background" />
      </div>
    </div>
  </div>
);

export default AgentPageSkeleton;
